import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';
import { getCompareOnboardingCookie, setCompareOnboardingCookie } from './compareOnboardingCookie';
import {
  AUTO_CLOSE_ONBOARDING_DELAY_MS,
  COMPARE_ONBOARDING_ENABLED_CONFIG,
  SHOW_ONBOARDING_DELAY_MS,
} from './constants';

interface IUseCompareOnboardingResult {
  open: boolean;
  closeHandler(): void;
}

export function useCompareOnboarding(enabled: boolean): IUseCompareOnboardingResult {
  const { config } = useApplicationContext();
  const [open, setOpen] = React.useState(false);

  const closeHandler = React.useCallback(() => {
    setOpen(false);
  }, []);

  React.useEffect(() => {
    const isOnboardingEnabled = config.get<boolean>(COMPARE_ONBOARDING_ENABLED_CONFIG) || false;

    if (!enabled || !isOnboardingEnabled || getCompareOnboardingCookie()) {
      return;
    }

    const timerId = setTimeout(() => {
      setOpen(true);
      setCompareOnboardingCookie();
    }, SHOW_ONBOARDING_DELAY_MS);

    return () => clearTimeout(timerId);
  }, [config, enabled]);

  React.useEffect(() => {
    if (!open) {
      return;
    }

    const timerId = setTimeout(closeHandler, AUTO_CLOSE_ONBOARDING_DELAY_MS);
    const closeByDocumentClick = () => closeHandler();

    document.addEventListener('click', closeByDocumentClick);

    return () => {
      clearTimeout(timerId);
      document.removeEventListener('click', closeByDocumentClick);
    };
  }, [closeHandler, open]);

  return { open, closeHandler };
}
